import * as React from 'react';
import { connect } from 'react-redux';
import { clearSelectedPartner } from '../../../../app/PartnerSearch/actions';
import { IPartnerSearchState } from '../../../../app/PartnerSearch/reducer';
import { DefaultButton } from '../../../ActionButton/ActionButton';
import { store } from '../../../../store';
import { ContentDialog } from '../../../ContentDialog';
import './PartnerResults.css';

interface IProps {
  partners: IPartnerSearchState;
}

class PartnerDialog extends React.Component<IProps> {
  closeDialog() {
    store.dispatch(clearSelectedPartner());
  }

  goToWebsite(url: string) {
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }
    window.open(url);
  }

  render() {
    const { partners } = this.props;
    const { selectedPartner: partner, showPartnerDialog } = partners;

    const hideCurrentModal = () => {
      this.closeDialog();
      document.body.classList.remove('preventModalScrolling');
    };

    if (!showPartnerDialog) {
      return null;
    }

    return (
      <ContentDialog
        loading={{
          title: false,
          content: !partners || !partner,
          aside: false,
        }}
        handleClose={hideCurrentModal}
        title={partner.name}
        content={
          <>
            <h3>{partner.activityType}</h3>
            <p>Partner information:</p>
            <ul>
              <li>
                Location: {partner.city}, {partner.country}
              </li>

              <li>Role: {partner.role}</li>

            </ul>

            <div className="partner-dialog__action-buttons">
              {partner.organizationUrl && (
                <DefaultButton text="Website" handleClick={() => this.goToWebsite(partner.organizationUrl)} />
              )}
            </div>
          </>
        }
        aside={null}
      />
    );
  }
}

const mapStateToProps = ({ partners }: any) => {
  return { partners };
};

export default connect(mapStateToProps)(PartnerDialog);
